module.exports = __webpack_public_path__ + "static/img/1.90b0ff04.jpg";